import { cx } from 'linaria';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BrandLink } from './components/brand-link';
import { brandLinkWrapper, otherProductsSection, title } from './styles';
import { getBreadcrumbs } from 'features/page-model';
import { useSelector } from 'react-redux';
import { getLinkedPagesBrand, getLinkedPagesList } from 'features/linked-pages';
import { getBrandLink } from 'utils/get-brand-link';
import { SectionHeader } from 'common/components';
import { patchUrlByLocale } from 'utils';

type OtherProductsProps = {
  className?: string;
};

export const OtherProducts: FC<OtherProductsProps> = ({ className }) => {
  const { t } = useTranslation();

  const breadcrumbs = useSelector(getBreadcrumbs)?.slice(-3);
  const linkedPages = useSelector(getLinkedPagesList);
  const { name: brandName } = useSelector(getLinkedPagesBrand) || {};

  const categories =
    breadcrumbs?.map((breadcrumb) => ({
      ...breadcrumb,
      icon: linkedPages?.find((page) => page.pageUrl === breadcrumb.link)?.icon,
    })) || [];

  const shouldRender = brandName || categories.length > 0;
  if (!shouldRender) return null;

  return (
    <section className={cx(otherProductsSection, className)}>
      <SectionHeader dataQA="other-products-title_mf-pdp" className={title}>
        {t('other-products.title')}
      </SectionHeader>
      <div className={brandLinkWrapper}>
        {brandName && <BrandLink type="brand" label={brandName} link={getBrandLink(brandName)} />}

        {categories.length > 0 &&
          categories.map(({ icon, label, link }) => (
            <BrandLink
              key={link}
              type="category"
              label={label}
              link={patchUrlByLocale(link)}
              imageUrl={icon}
            />
          ))}
      </div>
    </section>
  );
};
